import {
  Heart,
  MessageSquare,
  UserPlus,
  Award,
  TrendingUp,
  AtSign,
  Pin,
} from 'lucide-react';

export type NotificationType =
  | 'post_reply'
  | 'post_comment'
  | 'post_like'
  | 'comment_like'
  | 'mention'
  | 'post_pinned'
  | 'badge_earned'
  | 'level_up'
  | 'new_follower';

export const NOTIFICATION_ICONS: Record<NotificationType, typeof Heart> = {
  post_reply: MessageSquare,
  post_comment: MessageSquare,
  post_like: Heart,
  comment_like: Heart,
  mention: AtSign,
  post_pinned: Pin,
  badge_earned: Award,
  level_up: TrendingUp,
  new_follower: UserPlus,
};

export const NOTIFICATION_COLORS: Record<NotificationType, string> = {
  post_reply: 'text-blue-500',
  post_comment: 'text-blue-500',
  post_like: 'text-red-500',
  comment_like: 'text-red-500',
  mention: 'text-purple-500',
  post_pinned: 'text-amber-500',
  badge_earned: 'text-yellow-500',
  level_up: 'text-green-500',
  new_follower: 'text-primary',
};

export const NOTIFICATION_I18N_KEYS: Record<NotificationType, string> = {
  post_reply: 'notifications.repliedToPost',
  post_comment: 'notifications.commentedOnPost',
  post_like: 'notifications.likedPost',
  comment_like: 'notifications.likedComment',
  mention: 'notifications.mentionedYou',
  post_pinned: 'notifications.postPinned',
  badge_earned: 'notifications.earnedBadge',
  level_up: 'notifications.reachedLevel',
  new_follower: 'notifications.startedFollowing',
};

export function getNotificationLink(
  type: NotificationType,
  data: Record<string, unknown> | null | undefined
): string {
  const postId = data?.postId as string | undefined;
  const followerId = data?.followerId as string | undefined;
  switch (type) {
    case 'post_reply':
    case 'post_comment':
    case 'post_like':
    case 'post_pinned':
    case 'comment_like':
    case 'mention':
      return postId ? `/posts/${postId}` : '/';
    case 'new_follower':
      return followerId ? `/profile/${followerId}` : '/';
    case 'badge_earned':
    case 'level_up':
      return '/profile';
    default:
      return '/';
  }
}
